module.exports = __webpack_public_path__ + "static/media/ipad-pro-12.9-new-schedule-reduced.853df121.png";